import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { useMyContext } from '../context/Context';
import { makeStyles } from '@mui/styles';
import InputBase from '@mui/material/InputBase';
import { saveComment } from '../services/apiService';
import impstyles from '../styles/CommentStyles.module.scss';
import { ReactComponent as Pencil } from "../assets/Pencil-icon.svg";

import { PrimaryButton } from '../components/common/customButton';

const useStyles = makeStyles(theme => ({
  button: {
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none'
    }
  },
  textBox: {
    root: {
      width: '100%'
    }
  }
}));

const HostComments = props => {
  const cmtTxt = props.legacyCmtText;
  const textStyle = props.isDark ? { color: '#FFFFFF' } : {};
  return cmtTxt === '' || cmtTxt === undefined ?
    <> </> :
    <>
      <p className={impstyles.noteText} style={textStyle}>
        <span>Host Message:</span>
      </p>
      <p className={impstyles.noteText} style={textStyle}>{cmtTxt}</p>
    </>
};

const TextEditor = props => {
  const classes = useStyles();
  let text = props.commentObj['commentTxt'];
  const [value, setValue] = useState(text);
  const [isLoading, setIsLoading] = useState(false);
  const context = useMyContext();
  const handleChange = event => {
    setValue(event.target.value);
  };

  const updateComment = () => {
    props.commentObj['commentTxt'] = value;
    setIsLoading(true);
    const wpid = context.selectedItem?.wpidNbr ?? null;
    saveComment(
      context.selectedItem.itemNbr,
      context.selectedItem.legacyItemNbr,
      context.searchedDCNbr,
      props.commentObj,
      wpid
    ).then(() => {
      setIsLoading(false);
      props.updateCmtTxt(value);
    }).catch(err => {
      console.error(err);
      context.showMsgCallback('DDIR Save comment Failed');
    });
  };

  const discardChange = () => {
    setValue(text);
    props.updateCmtTxt(text);
  };

  return (<div className={impstyles.textEditor}>
    <span className={impstyles.textBox}>
      <form>
        <InputBase
          value={value}
          multiline
          maxRows={2}
          fullWidth
          onFocus={e =>
            e.currentTarget.setSelectionRange(
              e.currentTarget.value.length,
              e.currentTarget.value.length
            )}
          onChange={handleChange}
          inputProps={{
            style: props.isDark ? { color: '#FFFFFF' } : {}
          }}
        />
      </form>

    </span>
    <span className={impstyles.noteButtons}>
      <Button
        className={impstyles.closeButton}
        variant="text"
        onClick={discardChange}>
        <div>Close</div>
      </Button>
      <PrimaryButton
        className={classes.button}
        onClick={() => updateComment()}
        disabled={text === value && !isLoading}
        variant="contained"
        loading={isLoading}
        fullWidth={true}
        color="primary">
        Save
      </PrimaryButton>
    </span>
  </div>);
};

const RegualarComments = props => {
  const context = useMyContext();
  const commentObj = props.commentObj;
  let commentTxt = commentObj['commentTxt'];
  let [editing, setEditing] = useState(false);
  const textStyle = props.isDark ? { color: '#99ABBE' } : {};
  const pencilStyle = props.isDark ? { filter: 'brightness(0) invert(0.6)' } : {};

  const updateCmtTxt = val => {
    commentTxt = val;
    setEditing(!editing);
  };

  const handlePencilClick = () => {
    if (context.itemAvailable) setEditing(true);
  };

  return (
    <>
      <p className={impstyles.noteText} style={textStyle}>
        <span>Notes:</span>
        {commentTxt === '' && !editing && (
          <Pencil
            className={context.itemAvailable ? '' : impstyles.iconDisabled}
            style={pencilStyle}
            onClick={handlePencilClick}
          />
        )}
      </p>
      {commentTxt && !editing && (
        <p className={impstyles.noteText} style={textStyle}>
          {commentTxt}
          <Pencil style={pencilStyle} onClick={() => { setEditing(true); }} />
        </p>
      )}
      {editing && <TextEditor updateCmtTxt={updateCmtTxt} commentObj={commentObj} isDark={props.isDark} />}
    </>
  );
};

const commentSection = props => {
  return (
    <>
      <HostComments legacyCmtText={props.commentObj.legacyCmtText} isDark={props.isDark} />
      <RegualarComments commentObj={props.commentObj} isDark={props.isDark} />
    </>
  );
};

HostComments.propTypes = {
  legacyCmtText: PropTypes.string,
  isDark: PropTypes.bool
};

TextEditor.propTypes = {
  commentObj: PropTypes.object.isRequired,
  updateCmtTxt: PropTypes.func.isRequired,
  isDark: PropTypes.bool
};

RegualarComments.propTypes = {
  commentObj: PropTypes.object.isRequired,
  isDark: PropTypes.bool
};

commentSection.propTypes = {
  commentObj: PropTypes.object.isRequired,
  isDark: PropTypes.bool
};

export default commentSection;
